@if (modalStep == 'aporte_1') {
  <div>
    <form [formGroup]="form">
      <div class="row">
        <div class="col-8 text-right">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text border-0 bg-transparent pt-0 pr-4 pb-2 pl-0 font-weight-bold">Valor do aporte:</label>
            </div>
            <input class="mb-3 form-control" type="text" formControlName="valor" placeholder="000,00" mask="separator.2" prefix="R$ " thousandSeparator="." decimalMarker="," [dropSpecialCharacters]="true">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-8 text-right">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text border-0 bg-transparent pt-0 pr-4 pb-2 pl-0 font-weight-bold">Data do aporte:</label>
            </div>
            <input class="mb-3 form-control" type="date" formControlName="data" placeholder="dd/mm/aaaa" dropSpecialCharacters="false" >
          </div>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col text-right">
          <button class="btn btn-success" [disabled]="!form.valid || loading" (click)="salvarAporte()">
            Salvar
            @if (loading) {
              <i class="fas fa-spinner fa-spin"></i>
            }
          </button>
        </div>
      </div>
    </form>
  </div>
}

@if (modalStep == 'aporte_2') {
  <div>
    <div class="icon-center small">
      <i class="far fa-check-circle"></i>
    </div>
    <h3 class="title my-2 my-md-4">
      Aporte realizado com sucesso!
    </h3>
    <p class="text-center">
      O boleto está disponível em <strong>Financeiro &gt; Recebimentos</strong>, ou clicando <a routerLink="/logado/financeiro/recebimentos" data-dismiss="modal">aqui</a>.
    </p>
  </div>
}